import { getCurrentOrgQueryKey } from '@kaiizen/kai-pro-api';
import { useCachedQuery } from '@kaiizen/react-persistent-cache';
import { useKaiProApiClient } from '../useKaiProApiClient';

export const useCurrentOrg = () => {
  const kaiProApiClient = useKaiProApiClient();

  const queryKey = getCurrentOrgQueryKey(kaiProApiClient.token);

  const query = useCachedQuery(
    queryKey,
    () => kaiProApiClient.getCurrentOrg(),
    { enabled: !!kaiProApiClient.token },
  );

  return {
    ...query,
    currentOrg: query.data,
  };
};
